import React, { useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { RootState, useAppDispatch, useAppSelector } from '../../store/store';
import { handleToggleEnableUserDialog, enableUser } from '../../store/usermanagement-slice/usermanagement-slice';
import { Header } from '../common/Header';
import { enqueueSnackbar } from '../../store/app-slice/app';
import { handleNotificationVariant } from '../notifications/_common';
import Transition from '../common/Transition';

export const EnableUserDialog = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { enableUserDialog, enableUserBodyParams } = useAppSelector((state: RootState) => state.usermanagement);

  function handleClose() {
    dispatch(handleToggleEnableUserDialog({ open: false, body: null }));
  }

  function handleSubmit() {
    dispatch(enableUser(enableUserBodyParams)).then((res: any) => {
      if (res && res.payload) {
        dispatch(enqueueSnackbar({
          message: t(`${res.payload.message}`),
          options: {
            variant: handleNotificationVariant(res.payload.success),
            persist: !res.payload.success
          }
        }));
      }
    });
  }

  useEffect(() => {
    if (!enableUserDialog) {
      dispatch(handleToggleEnableUserDialog({ open: false, body: null }));
    }
  }, [enableUserDialog, dispatch]);

  return(
    <Dialog
      open={enableUserDialog}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
    >
      <Header title={t('USER_MANAGEMENT_ENABLE_DISABLE_TITLE', { 
        enable: enableUserBodyParams?.enable ? t('USER_MANAGEMENT_ENABLE') : t('USER_MANAGEMENT_DISABLE')
      })} />
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          {t('USER_MANAGEMENT_ENABLE_DISABLE_BODY', {
            email: enableUserBodyParams?.email,
            enable: enableUserBodyParams?.enable ? t('USER_MANAGEMENT_ENABLE')?.toLowerCase() : t('USER_MANAGEMENT_DISABLE')?.toLowerCase()
          })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button className="button-text-color" onClick={handleClose}>{t('CANCEL_BUTTON')}</Button>
        <Button className="button-text-color" onClick={handleSubmit}>{t('SUBMIT_BUTTON')}</Button>
      </DialogActions>
    </Dialog>
  );
};
